// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1DVC-","requiredAsterisk":"Info_requiredAsterisk__2yBy_"};